import {checkError, closeAlert, receiveErrorAlert, receiveSuccessAlert} from "../commonsActions";
import {
    getMaxNumberOfLoanPayments,
    saveLoanRetailerProperty,
    updateLoanRetailerProperty
} from "../../helpers/loanRetailerPropertyService";

export const GET_MAX_NUMBER_OF_LOAN_PAYMENTS = 'GET_MAX_NUMBER_OF_LOAN_PAYMENTS';

export const fetchMaxNumberOfLoanPayments = (query) => dispatch => {
    return getMaxNumberOfLoanPayments(query).then(res => {
        dispatch({
            type: GET_MAX_NUMBER_OF_LOAN_PAYMENTS,
            maxNumberOfPayments: res
        })
        setTimeout(() => {
            dispatch(closeAlert());
        }, 2000);
        return res;
    }, error => {
        console.log(error);
    })
};

export const saveSingleLoanRetailerProperty = property => dispatch => {
    return saveLoanRetailerProperty(property).then(res => {
        dispatch(receiveSuccessAlert('Update Successful'));
        setTimeout(() => {
            dispatch(closeAlert());
        }, 2000);
        return res;
    }, error => {
        dispatch(checkError(error));
        dispatch(receiveErrorAlert(error));
        setTimeout(() => {
            dispatch(closeAlert());
        }, 2000);
        throw error;
    })
};

export const updateSingleLoanRetailerProperty = property => dispatch => {
    return updateLoanRetailerProperty(property).then(res => {
        dispatch(receiveSuccessAlert('Update Successful'));
        setTimeout(() => {
            dispatch(closeAlert());
        }, 2000);
        return res;
    }, error => {
        dispatch(checkError(error));
        dispatch(receiveErrorAlert(error));
        setTimeout(() => {
            dispatch(closeAlert());
        }, 2000);
        throw error;
    })
};


// WEBPACK FOOTER //
// ./src/actions/loan/loanRetailerPropertyAction.js